module.exports = __webpack_public_path__ + "packs/media/images/Match-9be6af22fac6f236dd26ba702ce858e2.svg";